import { render, staticRenderFns } from "./SA.vue?vue&type=template&id=9bc243f6&scoped=true&"
import script from "./SA.vue?vue&type=script&lang=ts&"
export * from "./SA.vue?vue&type=script&lang=ts&"
import style0 from "./SA.vue?vue&type=style&index=0&id=9bc243f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc243f6",
  null
  
)

export default component.exports